export const BADGE_COLOR_MAPPER = {
  지인: {
    wrapper: 'var(--Orange-100)',
    text: 'var(--Orange-500)'
  },
  동료: {
    wrapper: 'var(--Purple-100)',
    text: 'var(--Purple-500)'
  },
  가족: {
    wrapper: 'var(--Green-100)',
    text: 'var(--Green-500)'
  },
  친구: {
    wrapper: 'var(--Blue-100)',
    text: 'var(--Blue-500)'
  }
};

export const PAPER_COLOR_MAPPER = {
  beige: 'var(--Beige-200)',
  purple: 'var(--Purple-200)',
  green: 'var(--Green-200)',
  blue: 'var(--Blue-200)'
};
